import { render, staticRenderFns } from "./Profits.vue?vue&type=template&id=66b6e659&scoped=true&"
import script from "./Profits.vue?vue&type=script&lang=js&"
export * from "./Profits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b6e659",
  null
  
)

export default component.exports